import { gql } from '@apollo/client';
import React from 'react';
import EntityPill from '../components/EntityPill';
import type { TopicPill_TopicFragment } from '../graphql/generated/graphqlTypes';
import topicPath from '../utils/url/topicPath';
import TopicNameWithIcon from './TopicNameWithIcon';

const TOPIC_PILL_FRAGMENT = gql`
  fragment TopicPill_topic on Topic {
    ...topicPath_topic
    ...TopicNameWithIcon_topic
  }
  ${topicPath.fragments.topic}
  ${TopicNameWithIcon.fragments.topic}
`;

interface TopicPillProps
  extends Pick<
    React.ComponentProps<typeof EntityPill>,
    'icon' | 'tooltip' | 'onRemove'
  > {
  topic: TopicPill_TopicFragment;
  highlighted?: boolean;
  name?: React.ReactNode;
}

const TopicPill = ({
  onRemove,
  topic,
  icon,
  tooltip,
  highlighted,
  name,
}: TopicPillProps) => (
  <EntityPill
    type="topic"
    onRemove={onRemove}
    to={topicPath(topic) || undefined}
    icon={icon}
    tooltip={tooltip}
  >
    <TopicNameWithIcon topic={topic} highlighted={highlighted} name={name} />
  </EntityPill>
);

TopicPill.fragments = {
  topic: TOPIC_PILL_FRAGMENT,
};

export default TopicPill;
